import { Badge } from "@repo/ui/components/ui/badge";
import type { AssessmentKind } from "../lib/assessment-detail-model";

/**
 * A tinted badge each, so the kinds separate at a glance in a mixed rail.
 * Neither reuses warning or destructive, which mean something else in the
 * response column.
 */
const KIND_CUE: Record<AssessmentKind, { label: string; className: string }> = {
  questionnaire: { label: "Questionnaire", className: "border-success/40 bg-success/10 text-success" },
  exam: { label: "Exam", className: "border-info/40 bg-info/10 text-info" },
  "performance-measure": { label: "Performance measure", className: "border-primary/40 bg-primary/10 text-primary" },
};

export function AssessmentKindBadge({ kind }: { kind: AssessmentKind }) {
  const { label, className } = KIND_CUE[kind];

  return (
    <Badge variant="outline" className={`font-normal ${className}`}>
      {label}
    </Badge>
  );
}
